// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__CBZBq","signInForm":"styles_signInForm__Bwc25","input":"styles_input__9E8Pd","checkboxContainer":"styles_checkboxContainer__tO4PJ"};